import {BrowserRouter as Router, Route, Switch} from "react-router-dom";

require('../js/bootstrap');

import React from 'react';

import ReactDOM from 'react-dom';

import moment from "moment";

moment.locale('de');

import {default as Home} from './views/home';
import {Leaderboard, OAuthAuthorize, OverallLeaderboard, TeamLeaderboard} from "./components";

ReactDOM.render(
    <Router>
        <Switch>

            <Route path={"/"} exact={true} >

                <Home/>

            </Route>

            <Route
                path={"/exchange"}
                component={OAuthAuthorize}
                //exact={true}
            />
        </Switch>
    </Router>,
    document.getElementById('root')
);
